import { render, staticRenderFns } from "./EnneagramViewMentor.vue?vue&type=template&id=7a7f4e10&"
import script from "./EnneagramViewMentor.vue?vue&type=script&lang=js&"
export * from "./EnneagramViewMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports